'use strict';

angular.module('chatEngine.engines.redirect', [])

.controller('EngineRedirectCtrl', ['$scope', 'Dialog', '$location', 'Engine',
function($scope, Dialog, $location, Engine) {
    $scope.init = function() {
        Engine.query(function(engines) {
            Engine.setData(engines);
            var defaultEngine = Engine.getDefaultEngine();
            if (defaultEngine === null) {
                $location.path('/engines');
                $location.replace();
            } else {
                $location.path('/engine/' + defaultEngine.id);
                $location.replace();
            }
        }, fetchError);
    };

    function fetchError() {
        Dialog.alert('Error', 'Something went wrong while fetching your engine, please try again later.');
        $location.path('/engines');
        $location.replace();
    }

    $scope.init();
}]);
